/*
 * @Description: 高度自适应
 * @version: 1.0.0
 * @Author: FJW
 * @Date: 2021-04-06 12:45:14
 * @LastEditors: FJW
 * @LastEditTime: 2024-11-06 13:55:05
 */
function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result // eslint-disable-line no-unused-vars
  const later = function () {
    const last = +new Date() - timestamp
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) {
          context = args = null
        }
      }
    }
  }
}

const doLeftResize = (el, binding, vnode) => {
  const { value } = binding
  let bottomOffset
  if (value) {
    bottomOffset = value.bottomOffset
  } else {
    bottomOffset = 50
  }
  const height = window.innerHeight - 85 - bottomOffset
  el.style.height = height + 'px'
}

import Vue from 'vue'

// v-el-height: 自适应高度
Vue.directive('el-height', {
  bind(el, binding, vnode) {
    el.resizeListener = () => doLeftResize(el, binding, vnode)
    window.addEventListener('resize', el.resizeListener)
  },
  inserted(el, binding, vnode) {
    setTimeout(() => {
      doLeftResize(el, binding, vnode)
    })
  },
  update(el, binding, vnode) {
    doLeftResize(el, binding, vnode)
  },
  unbind(el) {
    window.removeEventListener('resize', el.resizeListener)
  }
})

Vue.directive('outside', {
  bind(el, binding, vnode) {
    function clickHandler(e) {
      if (el.contains(e.target)) {
        return false
      }
      if (binding.expression) { // 执行方法
        binding.value && binding.value(e)
      }
    }
    el.__vueClickOutside__ = clickHandler
    document.addEventListener('click', clickHandler)
  },
  update() { },
  unbind(el, binding) {
    // 解除事件监听
    document.removeEventListener('click', el.__vueClickOutside__)
    delete el.__vueClickOutside__
  }
})
